import React from "react"

const ChartTooltip = (props) => {
  const {active, payload, label, formatter, labelFormatter, xDataKey} = props

  if (active && payload && payload.length) {
    return (
      <div className="recharts-tooltip-wrapper recharts-tooltip-wrapper-left recharts-tooltip-wrapper-top">
        <div
          className="recharts-default-tooltip"
          style={{
            margin: 0,
            padding: 10,
            backgroundColor: "rgb(255, 255, 255)",
            border: "1px solid rgb(204, 204, 204)",
            whiteSpace: "nowrap",
          }}
        >
          {labelFormatter && typeof labelFormatter === "function" && (
            <p className="recharts-tooltip-label">
              {`${xDataKey}:`}
              <b style={{fontWeight: 700}}>{labelFormatter(label)}</b>
            </p>
          )}
          {payload?.map((ele, indx) => (
            <p
              className="recharts-tooltip-content"
              key={indx}
              style={{color: ele?.color}}
            >
              {`${ele.name}:`} <b style={{fontWeight: 700}}>{formatter(ele.value)}</b>
            </p>
          ))}
        </div>
      </div>
    )
  }

  return null
}

export default ChartTooltip
